export const form_skillBook_add = {
  "fields": [
    { name: "header_info", type: "text", label: "Informazioni corso", isHeader: true },
    {
      "label": "Società erogante",
      "name": "providing_company",
      "required": false,
      "type": "text"
    },
    {
      "label": "Inserisci titolo",
      "name": "title",
      "required": true,
      "type": "text"
    },
    {
      "label": "Durata (minuti)",
      "name": "duration",
      "required": true,
      "type": "text"
    },
    { name: "header_log", type: "text", label: "Logistica", isHeader: true },
    {
      "label": "Modalità di formazione",
      "name": "trainingType",
      "required": false,
      "type": "select"
    },
    {
      "label": "Descrizione",
      "name": "description",
      "required": false,
      "type": "textarea"
    },
    {
      "label": "Data inizio corso",
      "name": "startDate",
      "required": true,
      "type": "date"
    },
    {
      "label": "Data fine corso",
      "name": "endDate",
      "required": true,
      "type": "date"
    }, 
    
    
    { name: "header_ob", type: "text", label: "Obiettivi formativi", isHeader: true },
    {
      "name": "area_domain",
      "type": "groups",
      "fields": [
        {
          "label": "Area di conoscenza",
          "name": "knowledge_area",
          "type": "select"
        },
        {
          "label": "Dominio di conoscenza",
          "name": "knowledge_domain",
          "dependentOn": "knowledge_area",
          "type": "select"
        }
      ],
      "label": "Knowledge Area & Domain"
    },
    {
      "label": "Capacità",
      "name": "capability",
      "required": false,
      "type": "multi-select"
    },
    {
      "label": "Campagna",
      "name": "campaign",
      "required": false,
      "type": "select"
    },
    {
      "label": "Punti",
      "name": "points",
      "required": false,
      "type": "text"
    },
    { name: "header_det", type: "text", label: "Dettagli didattici", isHeader: true },
    {
      "label": "Docente",
      "name": "teacher",
      "required": false,
      "type": "text"
    },
    
    {
      "label": "Crediti",
      "name": "credits",
      "required": false,
      "type": "text"
    },
    {
      "label": "ID Fonte",
      "name": "sourceId",
      "required": false,
      "type": "text"
    },
    {
      "label": "Fonte",
      "name": "source",
      "required": false,
      "type": "text"
    },
    {
      "label": "Codice",
      "name": "code",
      "required": false,
      "type": "text"
    },
    {
      "label": "Note aggiuntive",
      "maxValue": 500,
      "name": "notes",
      "required": false,
      "type": "text"
    },
    {
      "label": "Durata di partecipazione",
      "name": "durationParticipation",
      "required": false,
      "type": "text"
    },
    {
      "label": "Allegati",
      "name": "attachments",
      "required": false,
      "type": "multi-file"
    },
    { name: "header_ce", type: "text", label: "Certificati", isHeader: true },
    {
      "label": "Carica certificato",
      "name": "file",
      "required": false,
      "type": "file"
    },
    {
      "label": "Link certificato (Es.: https://)",
      "name": "link",
      "required": false,
      "type": "text"
    },
    {
      "label": "Data inizio validità del certificato",
      "name": "validationStartDate",
      "required": false,
      "type": "date"
    },
    {
      "label": "Data fine validità del certificato",
      "name": "validationEndDate",
      "required": false,
      "type": "date"
    }
  ]
};

export const form_skillBook_external_training_add = {
  "fields": [
    { name: "header_info", type: "text", label: "Informazioni corso", isHeader: true },
    {
      "label": "Ente Erogatore",
      "name": "dispenser",
      "required": true,
      "type": "text"
    },
    {
      "label": "Titolo corso",
      "name": "title",
      "required": true,
      "type": "text"
    },
    {
      "label": "Durata (minuti)",
      "name": "duration",
      "required": true,
      "type": "text"
    },
    {
      "label": "Costo",
      "name": "cost",
      "required": false,
      "type": "text"
    },
    { name: "header_log", type: "text", label: "Logistica", isHeader: true },
    {
      "label": "Sede",
      "name": "site",
      "required": false,
      "type": "text"
    },
    {
      "label": "Trasferta",
      "name": "businessTrip",
      "required": true,
      "type": "select"
    },
    {
      "label": "Data inizio corso",
      "name": "startDate",
      "required": true,
      "type": "date"
    },
    {
      "label": "Data fine corso",
      "name": "endDate",
      "required": true,
      "type": "date"
    },
    {
      "label": "Modalità di formazione",
      "name": "trainingType",
      "required": false,
      "type": "select"
    },
    {
      "label": "Tipologia",
      "name": "type",
      "required": false,
      "type": "text"
    },
    {
      "label": "Descrizione",
      "name": "description",
      "required": false,
      "type": "textarea"
    },
    { name: "header_det", type: "text", label: "Dettagli didattici", isHeader: true },
    {
      "label": "Docente",
      "name": "teacher",
      "required": false,
      "type": "text"
    },
    {
      "label": "Programma",
      "name": "plan",
      "required": false,
      "type": "text"
    },
    {
      "label": "Codice",
      "name": "code",
      "required": false,
      "type": "text"
    },
    {
      "label": "Note aggiuntive",
      "maxValue": 500,
      "name": "notes",
      "required": false,
      "type": "text"
    },
    {
      "label": "ID Fonte",
      "name": "sourceId",
      "required": false,
      "type": "text"
    },
    {
      "label": "Fonte",
      "name": "source",
      "required": false,
      "type": "text"
    },
    {
      "label": "Durata di partecipazione",
      "name": "durationParticipation",
      "required": false,
      "type": "text"
    },
    {
      "label": "Allegati",
      "name": "attachments",
      "required": false,
      "type": "multi-file"
    },
    { name: "header_ob", type: "text", label: "Obiettivi formativi", isHeader: true },
    {
      "label": "Motivazione",
      "name": "motivation",
      "required": false,
      "type": "text"
    },
    {
      "label": "Campagna",
      "name": "campaign",
      "required": false,
      "type": "select"
    },
    {
      "label": "Crediti",
      "name": "credits",
      "required": false,
      "type": "text"
    },
    {
      "label": "Punti",
      "name": "points",
      "required": false,
      "type": "text"
    },
    {
      "name": "area_domain",
      "type": "groups",
      "fields": [
        {
          "label": "Area di conoscenza",
          "name": "knowledge_area",
          "type": "select"
        },
        {
          "label": "Dominio di conoscenza",
          "name": "knowledge_domain",
          "dependentOn": "knowledge_area",
          "type": "select"
        }
      ],
      "label": "Knowledge Area & Domain"
    },
    {
      "label": "Capacità",
      "name": "capability",
      "required": false,
      "type": "multi-select"
    }
  ]
};
